import { invokeApi } from './Core';
const eventMap = new Map();
const eventGroup = {
    Network: {
        on: 'com.dywx.hybrid.event.NetworkEvent'
    },
    PageRefresh: {
        on: 'com.dywx.hybrid.event.RefreshEvent/listen'
    },
    MBack: {
        on: 'com.dywx.hybrid.event.MBack/listen',
        off: 'com.dywx.hybrid.event.MBack/removeListen'
    },
    Activity: {
        on: 'com.dywx.hybrid.event.ActivityEvent/listen',
        off: 'com.dywx.hybrid.event.ActivityEvent/removeListen'
    }
};
export function on(event, handler) {
    if (eventMap.has(event)) {
        const handlerArray = eventMap.get(event);
        if (handlerArray && handlerArray.indexOf(handler) === -1) {
            handlerArray.push(handler);
            eventMap.set(event, handlerArray);
        }
    }
    else {
        eventMap.set(event, [handler]);
        invokeApi({
            api: eventGroup[event].on,
            params: {},
            timeout: 0,
            callback: {
                resolve: value => {
                    const handlerArray = eventMap.get(event);
                    if (handlerArray) {
                        handlerArray.forEach(cb => {
                            cb(value);
                        });
                    }
                },
                reject: err => {
                    console.error(`hybrid event:${event}`);
                    throw err;
                }
            }
        });
    }
}
export function off(event, handler) {
    if (handler) {
        const handlerArray = eventMap.get(event) || [];
        const handlerIndex = handlerArray.indexOf(handler);
        if (handlerArray && handlerIndex !== -1) {
            handlerArray.splice(handlerIndex, 1);
            if (handlerArray.length > 0) {
                eventMap.set(event, handlerArray);
            }
            else {
                eventMap.delete(event);
            }
        }
    }
    else {
        eventMap.delete(event);
    }
}
